import { useMutation } from '@tanstack/react-query';
import { pensionSchemeService } from '../../../services/pension-scheme.service';

export function useSelectScheme() {
  return useMutation({
    mutationFn: (schemeData) => pensionSchemeService.selectScheme(schemeData),
    onSuccess: (data) => {
      console.log('Scheme selected successfully:', data);
    },
    onError: (error) => {
      console.error('Failed to select scheme:', error);
    }
  });
}
